import $ from "jquery";
//npm install swiper
import Swiper from 'swiper/bundle';

$(function() {
    $(".bl-wl-imageslider").each(function() {
        const $bl = $(this);
        initBlock($bl);
    });
});

function initBlock($bl) {
    const swiper = new Swiper($bl.find('.swiper').get(0), {
      //loop: true,
      //rewind: true,
      //autoHeight: true,

      /*
      speed: 1500,
      autoplay: {
        delay: 4000
      }
      */

      slidesPerView: "auto",
      spaceBetween: 25,
      //freeMode: true
    });
}
